import isPropValid from "@emotion/is-prop-valid";
import { spacing } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
export const AddonContainer = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  padding-right: ${spacing.base.m};
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWRkb25Db250YWluZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UZXh0RmllbGQvc3R5bGVkL0FkZG9uQ29udGFpbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sV0FBVyxNQUFNLHdCQUF3QixDQUFDO0FBQ2pELE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUN6RSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUV2QyxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUM7SUFDbEQsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQUE7bUJBQ2lCLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQzs7OztDQUloQyxDQUFDIn0=